import React from 'react'

import { Box, Button, Input, Modal, Stack, useBreakpoints } from '@procsea/design-system'

import { useUser } from 'src/contexts/userContext'

import { usePasswordUpdateForm } from './usePasswordUpdateForm'

interface PasswordUpdateModalProps {
  open: boolean
  onSubmitCallback?: () => void
  onAfterClose?: () => void
}

export const PasswordUpdateModal = ({
  open,
  onAfterClose,
  onSubmitCallback,
}: PasswordUpdateModalProps) => {
  const { isMobile } = useBreakpoints()
  const user = useUser()
  const { form, handleInputChange, handleSubmit } = usePasswordUpdateForm({ onSubmitCallback })

  const isUserPasswordSet = user?.userPasswordIsSet
  const modalTitle = isUserPasswordSet ? gettext('Update password') : gettext('Set a password')

  const { newPassword, confirmPassword } = form.watch()

  return (
    <Modal
      data-e2e="password-update-modal"
      disableClose={!isUserPasswordSet}
      header={modalTitle}
      open={open}
      afterClose={onAfterClose}
      width={isMobile ? '95%' : '450px'}
    >
      <form noValidate onSubmit={form.handleSubmit(handleSubmit)}>
        <Box inset="medium">
          <Stack spacing="large">
            <Input
              data-e2e="password-update-modal-password-input"
              errorMessage={form.formState.errors.newPassword?.message}
              fluid
              label={gettext('New password')}
              name="newPassword"
              onChange={handleInputChange}
              required
              type="password"
              value={newPassword}
            />

            <Input
              data-e2e="password-update-modal-confirm-password-input"
              errorMessage={form.formState.errors.confirmPassword?.message}
              fluid
              label={gettext('Confirm password')}
              name="confirmPassword"
              onChange={handleInputChange}
              required
              type="password"
              value={confirmPassword}
            />

            <Button data-e2e="password-update-modal-save-button" type="submit" variant="success">
              {gettext('Save')}
            </Button>
          </Stack>
        </Box>
      </form>
    </Modal>
  )
}
